//TRIGGER FUNCTIONS ON WINDOW SCROLL

var onScroll = function(event){

    var st = window.pageYOffset || document.documentElement.scrollTop,
        target = $('.topbar');

    if (st > 70) {
        target.addClass('scrolling');

        // if (st < lastY) {
        //     target.removeClass('scrollDown');
        //
        //     if(target.hasClass('triggered')) {
        //         target.removeClass('triggered');
        //     }
        //
        // } else {
        //     target.addClass('scrollDown');
        // }

    }else {
        target.removeClass('scrolling scrollDown');

        if(target.hasClass('triggered')) {
            target.removeClass('triggered');
        }
    }

    lastY = st;
};

$(window).on('scroll', onScroll);